function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 0C5.60742 0 5.20605 0.137695 4.92188 0.421875C4.6377 0.706055 4.5 1.10742 4.5 1.5V2.25H0V3.75H0.75V15.75C0.75 16.9834 1.7666 18 3 18H12C13.2334 18 14.25 16.9834 14.25 15.75V3.75H15V2.25H10.5V1.5C10.5 1.10742 10.3623 0.706055 10.0781 0.421875C9.79395 0.137695 9.39258 0 9 0H6ZM6 1.5H9V2.25H6V1.5ZM2.25 3.75H12.75V15.75C12.75 16.166 12.416 16.5 12 16.5H3C2.58398 16.5 2.25 16.166 2.25 15.75V3.75ZM3.75 6V14.25H5.25V6H3.75ZM6.75 6V14.25H8.25V6H6.75ZM9.75 6V14.25H11.25V6H9.75Z",
  fill: "black"
});

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.11b06ee5.svg";
export { ForwardRef as ReactComponent };